{
  "time": {
    "minutes": {
      "short_one": "{{ count }}m",
      "short_other": "{{ count }}m"
    },
    "seconds": {
      "short_one": "{{ count }}s",
      "short_other": "{{ count }}s"
    }
  },
  "{{count}}days_short_one": "{{count}}d",
  "{{count}}days_short_other": "{{count}}d",
  "{{count}}hours_short_one": "{{count}}h",
  "{{count}}hours_short_other": "{{count}}h",
  "{{count}}minutes_short_one": "{{count}}m",
  "{{count}}minutes_short_other": "{{count}}m"
}
